import { createFileRoute } from "@tanstack/react-router";
import { useEffect } from "react";

import { PairingPendingSurface } from "../components/auth/PairingRouteSurface";

export const Route = createFileRoute("/pair")({
  component: PairCompatibilityRedirectRoute,
});

function PairCompatibilityRedirectRoute() {
  useEffect(() => {
    const loginUrl = new URL("/login", window.location.href);
    loginUrl.search = window.location.search;
    loginUrl.hash = window.location.hash;
    window.location.replace(loginUrl.toString());
  }, []);

  return <PairingPendingSurface />;
}
